// extracted by mini-css-extract-plugin
export default {"inputWrapper":"GroupSelect_inputWrapper__YLHIs","selectInput":"GroupSelect_selectInput__7aVlU"};